import _ from 'lodash';
import moment from 'moment';

const formatBirthdateForApi = (birthdate) => {
  if (!birthdate) {
    return null;
  }
  const m = moment(birthdate, ['MM/DD/YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);
  if (m.isValid()) {
    return m.format('MM/DD/YYYY');
  }
  return birthdate;
};

/** Flat body for PUT /sso/register-verify (profile completion during signup). */
export const buildRegisterVerifyProfileBody = (form, birthdate) => {
  const state = _.get(form, 'state', null);
  const body = {
    firstName: _.get(form, 'firstName', null),
    lastName: _.get(form, 'lastName', null),
    streetNumber: _.get(form, 'streetNumber', null),
    street: _.get(form, 'street', null),
    addressLine2: _.get(form, 'addressLine2', null),
    city: _.get(form, 'city', null),
    state: state ? String(state).toUpperCase() : null,
    zip: _.get(form, 'zip', null),
    phone: form.phone.replace(/[^\d]/g, ''),
    birthdate: formatBirthdateForApi(birthdate),
  };
  if (form.middleName) {
    body.middleName = form.middleName;
  }
  if (form.suffix) {
    body.suffix = form.suffix;
  }
  return body;
};

/** Profile fields for PUT /sso/update-user ({ profileUpdate: ... }). */
export const buildProfileUpdate = (form, birthdate) => {
  const state = _.get(form, 'state', null);
  const profileUpdate = {
    firstName: _.get(form, 'firstName', null),
    lastName: _.get(form, 'lastName', null),
    streetNumber: _.get(form, 'streetNumber', null),
    street: _.get(form, 'street', null),
    addressLine2: _.get(form, 'addressLine2', null),
    city: _.get(form, 'city', null),
    state: state ? String(state).toUpperCase() : null,
    zip: _.get(form, 'zip', null),
    phone: form.phone.replace(/[^\d]/g, ''),
    verify: true,
    birthdate: formatBirthdateForApi(birthdate),
  };
  if (form.middleName) {
    profileUpdate.middleName = form.middleName;
  }
  if (form.suffix) {
    profileUpdate.suffix = form.suffix;
  }
  return profileUpdate;
};
